import { IResourceComponentsProps, useExport, useGetIdentity, useTranslate } from "@refinedev/core";

import {
    BooleanField,
    CreateButton,
    DateField,
    DeleteButton,
    EditButton,
    ExportButton,
    List,
    ShowButton,
    TagField,
    useTable,
} from "@refinedev/antd";

// It is recommended to use explicit import as seen below to reduce bundle size.
// import { IconName } from "@ant-design/icons";
import * as Icons from "@ant-design/icons";

import { Space, Table } from "antd";
import React, {useContext} from 'react';
import {ITurn} from '../../interfaces';
import {StoreContext} from '../../contexts/StoreContext';

export const TurnShow: React.FC<IResourceComponentsProps> = () => {
    const translate = useTranslate();
    const {value, value2} = useContext(StoreContext);
    const [store, setStore] = value;
    const { data: userIdentity } = useGetIdentity<any>();
    const {tableProps} = useTable<ITurn>({
        resource: "turns",
        meta: {populate: '*'},

        filters: {
            permanent: [
                {
                    field: "user][id]",
                    operator: "eq",
                    value: userIdentity?.id
                },
                {
                    field: "seller][id]",
                    operator: 'eq',
                    value: store?.id
                }
            ]
        }
    });

    const {triggerExport, isLoading: exportLoading} = useExport<ITurn>();

    return (
            <List
                title={translate('pages.turn.title', 'Turni')}
                headerProps={{
                    extra: [
                        <ExportButton
                            onClick={triggerExport}
                            loading={exportLoading}
                        />
                    ],
                }}
            >
                <Table size="small" {...tableProps} rowKey="id"
                       onRow={(record) => {
                           return {
                               onClick: () => {
                                   // console.log("turn", record);
                               },
                           };
                       }}
                       sticky={true}

                       pagination={{
                           ...tableProps.pagination,
                           showSizeChanger: true,
                       }}>
                    {/*<Table.Column dataIndex="id" key="id" title="ID"/>*/}
                    <Table.Column
                        dataIndex="user"
                        key="user"
                        title={translate('pages.category.user', 'Utente')}
                        render={(value) => <TagField value={value.name + ' ' + value.surname} />}
                    />
                    <Table.Column
                        dataIndex="dataIn"
                        key="dataIn"
                        title={translate('pages.category.dataIn', 'Data Apertura')}
                        render={(value) => <DateField value={value} format={'DD-MM-YYYY HH:mm'} />}
                    />
                    <Table.Column
                        dataIndex="dataOut"
                        key="dataOut"
                        title={translate('pages.category.dataOut', 'Data Chiusura')}
                        render={(value) => <DateField value={value} format={'DD-MM-YYYY HH:mm'} />}
                    />
                    <Table.Column<{ id: string }>
                        title={translate('pages.docType.action', 'Azioni')}
                        dataIndex="actions"
                        key="actions"
                        render={(_, record) => (
                            <Space>
                                <ShowButton
                                    hideText
                                    size="small"
                                    recordItemId={record.id}
                                />
                            </Space>
                        )}
                    />

                </Table>
            </List>
    );
};
